<div class="w3-sidebar w3-bar-block w3-animate-left sidebar-transition"
    id="mySidebar">
    <div class="row mb-3px custText top-bgcolor" *ngIf="createcandidate_form">
        <div class="col d-flex justify-content-between pt-12">
            <span> <img src="../../assets/images/webtree.png"> </span> <span class="pointer trx" (click)="dismiss()"><i
                    class="fas fa-times"></i></span>
        </div>
    </div>
    <div class="mb-3 create-div"  *ngIf="createcandidate_form">
        <form [formGroup]="candidate_form">
            <div class="row mb-3 mt-3">
                <div class="col d-flex justify-content-between">
                    <span class="font-weight-500 f-14">Add Candidate</span>
                </div>
            </div>
            <div class="f-12 font-weight-500 mb-4 mr-4">
                Upload Resume
                <div class="ats-upload-btn-2 mt-3px">
                    <div class="col px-0 d-flex justify-content-between">
                        <span class="f-12 gray-text px-6-py-12 text-truncate" *ngIf="!resumeFile">
                            <i class="fas fa-file-upload mr-2"></i> Drag and drop file here
                        </span>

                        <div class="f-12 gray-text d-flex px-6-py-12" style="z-index:9999 ;" *ngIf="resumeFile">
                            <span class="text-truncate" style="width:100px">
                                {{resumeFile.filename}}
                            </span>
                            <i class="fas fa-times ml-2" (click)="removeFile()"></i>
                        </div>
                        <span style="height: 36px;" class="f-12">
                            <button data-testid="auto-app-create-candidate-button-1" type="button" class="btn-trms-medium" data-dismiss="modal">Browse files</button>
                        </span>
                    </div>

                    <input data-testid="auto-app-create-candidate-input-1" type="file" #document (change)="uploadFile($event)"
                        accept=".doc,.docx,.txt,.pdf, .dot,.rtf,.odt,.htm,.html">
                </div>
                <p [ngClass]="['text-left','my-1','text-danger']" *ngIf="filesizeExceeded==true">File size should not exceed more then 5 mb</p>
            </div>

            <div class="row mr-2">
                <div class="col">
                    <div class="f-12 font-weight-500 mb-4"> First Name <span class="text-danger">*</span>
                        <input data-testid="auto-app-create-candidate-input-2" type="text" placeholder="Enter First Name" class="wc-form-control nobg mt-3px"
                            formControlName="firstName">
                        <p *ngIf="candidate_form.get('firstName').errors?.required && (candidate_form['controls'].firstName.dirty || candidate_form['controls'].firstName.touched)"
                            [ngClass]="['text-left','my-1','text-danger']">First Name is required</p>
                            <p *ngIf="candidate_form['controls'].firstName.hasError('pattern')" class="text-danger f-12 mb-0 pt-1">
                                HTML tags are not allowed</p>
                    </div>
                </div>
                <div class="col">
                    <div class="f-12 font-weight-500 mb-4"> Last Name <span class="text-danger">*</span>
                        <input data-testid="auto-app-create-candidate-input-3" type="text" placeholder="Enter Last Name" class="wc-form-control nobg mt-3px"
                            formControlName="lastName">
                        <p *ngIf="candidate_form.get('lastName').errors?.required && (candidate_form['controls'].lastName.dirty || candidate_form['controls'].lastName.touched)"
                            [ngClass]="['text-left','my-1','text-danger']">Last Name is required</p>
                            <p *ngIf="candidate_form['controls'].lastName.hasError('pattern')" class="text-danger f-12 mb-0 pt-1">
                                HTML tags are not allowed</p>
                    </div>
                </div>
            </div>

            <div class="mr-4">
                <div class="f-12 font-weight-500 mb-4"> Company Name
                    <!-- <input data-testid="auto-app-create-candidate-input-4" type="text" placeholder="Enter Company Name" class="wc-form-control nobg mt-3px"
                    formControlName="companyName"> -->

                    <input data-testid="auto-app-create-candidate-input-5" (input)="searchCompany()" type="text" placeholder="Enter Company Name"
                        #trigger="matAutocompleteTrigger" (keyup.enter)="trigger.closePanel()"
                        class="wc-form-control nobg mt-3px text-capitalize" formControlName="companyName"
                        [matAutocomplete]="company_auto">

                    <mat-autocomplete #company_auto="matAutocomplete">
                        <mat-option *ngFor="let company of companylist" [value]="company">
                            {{company}}
                        </mat-option>
                    </mat-autocomplete>


                    <p *ngIf="candidate_form.get('companyName').errors?.required && (candidate_form['controls'].companyName.dirty || candidate_form['controls'].companyName.touched)"
                        [ngClass]="['text-left','my-1','text-danger']">Company Name is required</p>
                        <p *ngIf="candidate_form['controls'].companyName.hasError('pattern')" class="text-danger f-12 mb-0 pt-1">
                            HTML tags are not allowed</p>
                </div>

                <div class="f-12 font-weight-500 mb-4"> Job Name
                    <!-- <input data-testid="auto-app-create-candidate-input-6" type="text" placeholder="Enter Job Name" class="wc-form-control nobg mt-3px"
                    formControlName="jobName"> -->

                    <input data-testid="auto-app-create-candidate-input-7" (input)="searchJobs()" type="text" placeholder="Enter Job Title"
                        #trigger="matAutocompleteTrigger" (keyup.enter)="trigger.closePanel()"
                        class="wc-form-control nobg mt-3px text-capitalize" formControlName="jobName" [matAutocomplete]="jobs_auto">

                    <mat-autocomplete #jobs_auto="matAutocomplete">
                        <mat-option *ngFor="let job of joblist" [value]="job">
                            {{job}}
                        </mat-option>
                    </mat-autocomplete>

                    <p *ngIf="candidate_form.get('jobName').errors?.required && (candidate_form['controls'].jobName.dirty || candidate_form['controls'].jobName.touched)"
                        [ngClass]="['text-left','my-1','text-danger']">Job Name is required</p>
                        <p *ngIf="candidate_form['controls'].jobName.hasError('pattern')" class="text-danger f-12 mb-0 pt-1">
                            HTML tags are not allowed</p>
                </div>

                <div class="f-12 font-weight-500 mb-4"> Location
                    <!-- <input data-testid="auto-app-create-candidate-input-8" type="text" placeholder="Enter Work Location" class="wc-form-control nobg mt-3px"
                    formControlName="worklocation"> -->

                    <input data-testid="auto-app-create-candidate-input-9" (input)="searchLocation()" type="text" placeholder="Enter Work Location"
                        #trigger="matAutocompleteTrigger" (keyup.enter)="trigger.closePanel()"
                        class="wc-form-control nobg mt-3px text-capitalize" formControlName="worklocation"
                        [matAutocomplete]="location_auto">

                    <mat-autocomplete #location_auto="matAutocomplete">
                        <mat-option *ngFor="let location of locationlist" [value]="location">
                            {{location}}
                        </mat-option>
                    </mat-autocomplete>


                    <p *ngIf="candidate_form.get('worklocation').errors?.required && (candidate_form['controls'].worklocation.dirty || candidate_form['controls'].worklocation.touched)"
                        [ngClass]="['text-left','my-1','text-danger']">Work Location is required</p>
                        <p *ngIf="candidate_form['controls'].worklocation.hasError('pattern')" class="text-danger f-12 mb-0 pt-1">
                            HTML tags are not allowed</p>
                </div>

                <div class="f-12 font-weight-500 mb-4"> Public Profile Link <span class="text-danger">*</span>
                    <input data-testid="auto-app-create-candidate-input-10" type="text" placeholder="Enter Public Profile Link" class="wc-form-control nobg mt-3px"
                        formControlName="publicProfileLink">
                    <p *ngIf="candidate_form.get('publicProfileLink').errors?.required && (candidate_form['controls'].publicProfileLink.dirty || candidate_form['controls'].publicProfileLink.touched)"
                        [ngClass]="['text-left','my-1','text-danger']">Public Profile Link is required</p>
                    <p class="text-danger f-12 pt-1"
                        *ngIf="candidate_form['controls'].publicProfileLink.hasError('pattern')">Must be a
                        valid URL</p>
                </div>

                <div class="f-12 font-weight-500 mb-4"> Source <span class="text-danger">*</span>
                    <div class="position-relative">
                        <!-- <span class="selectdrop-down position-absolute tr0 mt-2 mr-2 gray-text">
                            <i class="fas fa-chevron-down"></i>
                        </span>
                        <select data-testid="auto-app-create-candidate-select-1" class="wc-form-control nobg position-relative mt-3px" formControlName="source">
                            <option value='' disabled>Select Source</option>
                            <option *ngFor="let x of sourcelist" [value]="x">{{x}}</option>
                        </select> -->
                        <div class="position-relative gray-text mt-3px">
                            <input data-testid="auto-app-create-candidate-input-11" type="text" placeholder="Select Source" #trigger1="matAutocompleteTrigger" (input)="getSourceList()"
                                (keyup.enter)="trigger1.closePanel()" class="wc-form-control nobg text-capitalize" #talentpool formControlName="source"
                                [matAutocomplete]="source_list">

                            <mat-autocomplete #source_list="matAutocomplete">
                                <mat-option *ngFor="let x of sourcelist_data" [value]="x"> {{x}} </mat-option>
                            </mat-autocomplete>
                        </div>
                        </div>
                    <p *ngIf="candidate_form.get('source').errors?.required && (candidate_form['controls'].source.dirty || candidate_form['controls'].source.touched)"
                        [ngClass]="['text-left','my-1','text-danger']">Source is required</p>
                </div>


                <div class="f-12 font-weight-500 mb-4"> Select Talentpool
                    <div class="position-relative">
                        <div class="position-relative gray-text mt-3px">
                            <input data-testid="auto-app-create-candidate-input-12" (input)="getAllTalentpool()" type="text" placeholder="Select Talentpool"
                                #trigger="matAutocompleteTrigger" (click)="getAllTalentpool()"
                                (mouseout)="getAllTalentpool()" (keyup.enter)="trigger.closePanel()"
                                class="wc-form-control nobg" #talentpool formControlName="talentpoolname"
                                [matAutocomplete]="talentpool_name">

                            <mat-autocomplete #talentpool_name="matAutocomplete">
                                <mat-option *ngFor="let talentpool of talentpoolslist" [value]="talentpool.name"
                                    (onSelectionChange)="openConfirmationModal(talentpool)">
                                    {{talentpool.name}}
                                </mat-option>
                            </mat-autocomplete>
                        </div>
                    </div>
                    <p *ngIf="noTalentpoolError" [ngClass]="['text-left','my-1','text-danger']">No Such Talentpool</p>
                </div>
            </div>

        </form>
    </div>

    <div *ngIf="createcandidate_form">
        <button data-testid="auto-app-create-candidate-button-2" type="button" class="btn-trms-medium" data-dismiss="modal" (click)="createCandidate()" [disabled]="addCandidateSpinner">
          <span [ngClass]="{ 'spinner-border text-light spinner-size': addCandidateSpinner }" [ngStyle] = "{ 'width: 20px; height: 20px;': addCandidateSpinner }">
          {{addCandidateSpinner ? '' : 'Add Candidate'}}
        </span>
        </button>
    </div>


    <div *ngIf="!createcandidate_form" class="text-center create-div-1">

        <div class="col">
            <img src="./../../../assets/candidate-success.png" alt="img-fluid">
        </div>

        <p class="font-weight-500">
            Candidate added successfully.
        </p>

        <p class="f-14 font-weight-500">Update candidate pipeline status
            <i class="fas fa-info-circle text-dis"[ngbTooltip]="pipelineplaceHolder"
                placement="bottom"></i>
        </p>

        <ng-template #pipelineplaceHolder>
            <p> <span class="hot-dot mr-1"></span>Hot candidate </p>
            <p class="mr-3"> All Signs Point To “Go” </p>
            <p> <span class="warm-dot mr-1"></span>Warm candidate </p>
            <p class="mr-3"> Interested, But Not Ready,
                Able Or A Good Fit
            </p>
            <p> <span class="cold-dot mr-1 "></span>Cold candidate </p>
            <p class="mr-3"> Casual Contacts and Candidates
                For Re-engagement
            </p>
        </ng-template>


        <p class="f-12">Pipeline Status</p>
        <span class="position-relative mb-1 d-flex pl-0 mr-5 ml-5">
            <select data-testid="auto-app-create-candidate-select-2" class="nobg wc-form-control pipeline-text-border" [(ngModel)]="talentvalue" (change)="talentErrorMessage = ''">
                <option value="null" disabled selected>Select</option>
                <option *ngFor="let status of pipeline_list" [value]="status"> {{status}} Candidate </option>
            </select>
            <span class="selectdrop-down position-absolute f-12 mt-3 mr-5 tr-x"> <i
                    class="fas fa-chevron-down"></i></span>
        </span>
        <p class="text-danger">
            {{talentErrorMessage}}
        </p>
        <div class="col-md-10 mx-auto d-flex mt-4">
            <button data-testid="auto-app-create-candidate-button-3" class="btn-trms-small" (click)="SaveTalent();">Done</button>
        </div>

    </div>

    <ng-template #successModal class="modal">
        <div class="modal-content">
            <div class="modal-body px-6 pb-6 pt-3">
                <div class="row mb-3">
                    <div class="col pb-5">
                        <button data-testid="auto-app-create-candidate-button-4" type="button" class="close position-absolute tr0" data-dismiss="modal"
                            aria-label="Close" (click)="modaldismiss()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col text-center">
                        <img src="./../../../assets/images/success-vector.png" alt="img-fluid">
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col">
                        <span class="text-center">CONGRATULATIONS !!!</span>
                        <span class="text-center">{{successMessage}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-10 mx-auto d-flex">
                        <button data-testid="auto-app-create-candidate-button-5" class="btn-trms-white mr-3" (click)="modaldismiss()">CANCEL</button>
                        <button data-testid="auto-app-create-candidate-button-6" class="btn-trms-small" (click)="modaldismiss()">DONE</button>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #errorModal class="modal">
        <div class="modal-content">
            <div class="modal-body px-6 pb-6 pt-3">
                <div class="row mb-3">
                    <div class="col pb-5">
                        <button data-testid="auto-app-create-candidate-button-7" type="button" class="close position-absolute tr0" data-dismiss="modal"
                            aria-label="Close" (click)="modaldismiss()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col text-center">
                        <img src="./../../../assets/images/error-vector.png" alt="img-fluid">
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col">
                        <span class="text-center">{{errorMessage}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-10 mx-auto d-flex">
                        <button data-testid="auto-app-create-candidate-button-8" class="btn-trms-small" (click)="modaldismiss();">CLOSE</button>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>


    <ng-template #duplicatecandidate class="modal">
        <div class="modal-content">
            <div class="modal-body px-6 pb-6 pt-3">
                <div class="row mb-3">
                    <div class="col pb-5">
                        <button data-testid="auto-app-create-candidate-button-9" type="button" class="close position-absolute tr0" data-dismiss="modal"
                            aria-label="Close" (click)="modaldismiss()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col text-center">
                        <img src="./../../../assets/images/duplicate-found.png" alt="img-fluid">
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col text-center">
                        <span class="text-center">This Candidate already Exist</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-10 mx-auto d-flex">
                        <button data-testid="auto-app-create-candidate-button-10" class="btn-trms-white mr-3" (click)="modaldismiss();">CLOSE</button>
                        <button data-testid="auto-app-create-candidate-button-11" class="btn-trms-medium"
                            (click)="openDuplicateCandidateProfile();">Show Profile</button>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>


<div class="w3-overlay w3-animate-opacity close-overlay-transition" (click)="dismiss()" id="myOverlay">
</div>
